










import { Component, Prop, Vue } from 'vue-property-decorator';
import { Auth } from '@/kuroco_api/core/Auth';

@Component({})
export default class App extends Vue {
  async created() {
    Auth.onErrorHandler = async (res) => {
      this.$router.push({ path: '/sub/login' });
      (this as any).$snack.danger({ text: 'ログインしてください。', button: 'OK' });
    };
  }
}
